import {Component, OnDestroy, OnInit} from '@angular/core';
import {AppState} from '../reducers';
import {Store} from '@ngrx/store';
import {getCurrentSetYear, getSelectedCrop, getSelectedState} from '../reducers/FormFilter.Reducer';
import {IYear} from '../models/IYearModel';
import {IStates} from '../models/IStatesModel';
import {Observable} from 'rxjs/index';
import * as PriceDiscoveryActions from '../actions/PriceDiscoveryActions';
import {IPriceDiscoveryModel} from '../models/IPriceDiscoveryModel';
import {getPriceDiscovery} from '../reducers/PriceDiscoveryReducer';
import {ICommodities} from '../models/ICommodityModel';

@Component({
  selector: 'app-price-discovery',
  templateUrl: './price-discovery.component.html',
  styleUrls: ['./price-discovery.component.scss']
})
export class PriceDiscoveryComponent implements OnInit, OnDestroy {

  private stateSubscription$: Observable<IStates>;
  private yearSubscription$: Observable<IYear>;
  public priceDiscoverySubscription$: Observable<Array<IPriceDiscoveryModel>>;
  private commoditySubscription$: Observable<ICommodities>;
  private selectedCommodity: ICommodities;
  public selectedState: IStates;
  public selectedYear: IYear;
  public priceDiscovery: Array<IPriceDiscoveryModel>;


  constructor(private store: Store<AppState>) {
    this.stateSubscription$ = store.select(getSelectedState);
    this.yearSubscription$ = store.select(getCurrentSetYear);
    this.priceDiscoverySubscription$ = store.select(getPriceDiscovery);
    this.commoditySubscription$ = store.select(getSelectedCrop);
  }

  ngOnInit() {
    this.yearSubscription$.subscribe((value: IYear) => {
      this.selectedYear = value;
      if (this.selectedState && this.selectedYear) {
        this.store.dispatch(PriceDiscoveryActions.UpdateCropsAction({year: this.selectedYear, state: this.selectedState}));
      }
    });
    this.stateSubscription$.subscribe((value: IStates) => {
      this.selectedState = value;
      this.store.dispatch(PriceDiscoveryActions.UpdateCropsAction({year: this.selectedYear, state: this.selectedState}));
    });
    this.priceDiscoverySubscription$.subscribe((priceDiscovery: Array<IPriceDiscoveryModel>) => {
      this.priceDiscovery = priceDiscovery;
    });

    this.commoditySubscription$.subscribe((value: ICommodities) => {
      this.selectedCommodity = value;
    });

  }

  isViewable(commodityCode: string) {
    if (this.selectedCommodity) {
      return this.selectedCommodity.CommodityCode !== commodityCode;
    }
  }

  ngOnDestroy() {
  }

}
